export default __webpack_public_path__ + "static/media/correction.0c264ae7.jpg";